import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { IMaskInput } from "react-imask";
import axiosInstance from "services/axiosInstance";
import ReactLoading from "react-loading";
import * as S from "./styled";
/**
 * hooks
 */
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
/**
 * Utils 
*/
import { checkCEP } from "utils/CheckCEP";
/**
 * Components
 */
import ProgressBar from "../../../ProgressBar";
import LayoutModal from "../../../LayoutModal";
import ActionButtonIcon from "../../../Button/ActionButtonIcon";
/**
 * Icons 
*/
import { MagnifyingGlass } from "@phosphor-icons/react";

interface IUpdate {
  isOpenModalAdress: boolean;
  setModalClose: () => void;
  idCustom: number | null;
  selectedUrlId: number | null;
  refreshFrames: () => void;
}

type Inputs = {
  customer_id: number,
  cep: string,
  street: string,
  neighborhood: string,
  number: string,
  city: string,
  uf: string,
  complement: string,
  reference: string
};

export default function UpdateAdress({
  isOpenModalAdress,
  setModalClose,
  selectedUrlId,
  idCustom,
  refreshFrames
}: IUpdate) {
  const {
    register,
    control,
    reset,
    handleSubmit: handleFormSubmit,
    formState: { errors },
    setValue
  } = useForm<Inputs>();

  const [isLoadSearch, setIsLoadSearch] = useState(false);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [inputValue, setInputValue] = useState('');
  const [dataAddress, setDataAddress] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        if (selectedUrlId !== null) {
          const response = await axiosInstance.get(`address/${selectedUrlId}`);
          const addressData = response.data;
          for (const key in addressData) {
            setValue(key as keyof Inputs, addressData[key]);
          }
        } else {
          console.log("Dado não encontrado!");
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    fetchData();
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(`address/${selectedUrlId}`, 'PATCH', { ...data, customer_id: idCustom });
      if (response.status === 200) {
        alert("Endereço atualizado com sucesso!");
        onClose();
        refreshFrames();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o usuário.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  useEffect(() => {
    if (dataAddress) {
      setValue('street', dataAddress.logradouro || '');
      setValue('neighborhood', dataAddress.bairro || '');
      setValue('city', dataAddress.localidade || '');
      setValue('uf', dataAddress.uf || '');
    }
  }, [dataAddress, setValue]); // Atualiza os campos quando dataAddress mudar

  if (isOpenModalAdress && selectedUrlId) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Editar Endereço"
        subTitle="Atualize informações do endereço do cliente."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"
        nameCancel="Atualizar depois">
        <S.ContentProgress>
          <ProgressBar name="Informações" />
          <ProgressBar name="Endereço" active={true} />
        </S.ContentProgress>
        <S.Container>
          <S.FormInput>
            <S.Label>
              CEP
              <span>*</span>
            </S.Label>
            <S.ContentInput>
              <Controller
                name="cep"
                control={control}
                render={({ field }) => (
                  <IMaskInput
                    id="cep"
                    mask="00.000-000"
                    placeholder="00.000-000"
                    onAccept={(value: string) => {
                      field.onChange(value);
                      setInputValue(value); // Atualiza o estado
                    }}
                    {...field}
                  />

                )}
              />
              <S.ButtonIcon
                onClick={() => checkCEP(inputValue, setDataAddress, setIsLoadSearch)}>
                {isLoadSearch ? (
                  <ReactLoading
                    type="spokes"
                    color="red"
                    height="20px"
                    width="20px"
                  />
                ) : (
                  <MagnifyingGlass size={20} />
                )}
              </S.ButtonIcon>
            </S.ContentInput>

            {errors.cep && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>Cidade</S.Label>
              <S.Input
                type="text"
                placeholder="Informe a cidade"
                {...register("city")} />
            </S.FormInput>

            <S.FormInput>
              <S.Label>UF</S.Label>
              <S.Input type="text" placeholder="AM" {...register("uf")} />
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>Rua</S.Label>
            <S.Input type="text" placeholder="Informe a rua" {...register("street")} />
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>Bairro</S.Label>
              <S.Input type="text" placeholder="Informe a cidade" {...register("neighborhood")} />
            </S.FormInput>

            <S.FormInput>
              <S.Label>N°</S.Label>
              <S.Input type="text" placeholder="AM" {...register("number")} />
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>Referência</S.Label>
            <S.Input type="text" placeholder="Campo opcional" {...register("reference")} />
          </S.FormInput>

          <S.FormInput>
            <S.Label>Complemento</S.Label>
            <S.Input type="text" placeholder="Campo opcional" {...register("complement")} />
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
